import { Component, computed, inject, OnInit, signal, PLATFORM_ID } from '@angular/core';
import { AuctionListingService } from '../../../../services/bidder-community/auction-listing/auction-listing.service';
import { AuctionListingVerticalViewComponent } from '../auction-listing-vertical-view/auction-listing-vertical-view.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faImage, faList } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { AuctionListingHorizontalViewComponent } from '../auction-listing-horizontal-view/auction-listing-horizontal-view.component';
import { PaginatorModule } from 'primeng/paginator';
import { MultiSelectModule } from 'primeng/multiselect';
import { isPlatformBrowser } from "@angular/common";
import { ApiService } from '../../../../services/api.service';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../services/authentication/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { distinctUntilChanged, skip, Subscription } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { IAuctionListing } from '../../../../models/IAuctionListing';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-auction-listing',
  imports: [AuctionListingVerticalViewComponent,
    CommonModule,
    FontAwesomeModule,
    ButtonModule,
    SelectButtonModule,
    MultiSelectModule,
    FormsModule,
    AuctionListingHorizontalViewComponent,
    PaginatorModule,
    SelectModule,
    DialogModule,
    ProgressSpinnerModule

  ],
  templateUrl: './auction-listing.component.html',
  styleUrl: './auction-listing.component.scss',
  providers: [DynamicDialogRef]
})
export class AuctionListingComponent implements OnInit {

  private readonly auctionListingService = inject(AuctionListingService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly apiService = inject(ApiService);
  private readonly route = inject(ActivatedRoute);
  isAuthenticated = this.oidcSecurityService.authenticated;
  private readonly platformId = inject(PLATFORM_ID);
  authSubscription!: Subscription;



  protected icons = {
    faImage: faImage,
    faList: faList
  }

  selectedCauses = signal<string[]>([]);

  auctions = this.auctionListingService.auctionListingSignal;
  causes = () => this.auctionListingService.causesSignal() ?? [];
  country = this.apiService.countrySignal;
  states = this.apiService.stateSignal;
  isLoading = this.auctionListingService.isLoading;
  selectedSortSignal = signal('');

  selectedCountries = signal<string | null>(null);
  selectedState = signal<string | null>(null);
  selectedCategory = signal<string | null>('current');

  isMobile!: boolean;
  bottomSheetCausesVisible = false;
  bottomSheetCountryVisible = false;
  bottomSheetStateVisible = false;


  ItemListOptions: any[] = [{ label: 'Image View', value: 'image' }, { label: 'List View', value: 'list' }];
  viewMode: 'image' | 'list' = 'image';
  isCommunityTheme: string = 'community';

  buttons = [
    { id: 'current', label: 'All Auctions' },
    { id: 'closing', label: 'Closing Soon' },
    { id: 'live', label: 'Live Events' },
    { id: 'local', label: 'Near Me' }
  ]

  sortFilters = [
    { label: 'Cause Category - Ascending', value: 'CAUSE_ASC' },
    { label: 'Cause Category - Descending', value: 'CAUSE_DESC' },
    { label: 'Close Date - Ascending', value: 'DATE_ASC' },
    { label: 'Close Date - Descending', value: 'DATE_DESC' },
    { label: 'Location - Ascending', value: 'LOC_ASC' },
    { label: 'Location- Descending', value: 'LOC_DESC' },
    { label: 'Organization Name - Ascending', value: 'ORG_ASC' },
    { label: 'Organization Name - Descending', value: 'ORG_DESC' },
  ];

  sortedItems = computed(() => {
    const sortValue = this.selectedSortSignal();

    const auctions = this.filteredAuctions();

    if (!auctions) {
      return [];
    }

    return [...auctions ?? []].sort((a, b) => {

      switch (sortValue) {
        case 'CAUSE_ASC':
          return a.orgCause.localeCompare(b.orgCause);
        case 'CAUSE_DESC':
          return b.orgCause.localeCompare(a.orgCause);
        case 'ORG_ASC':
          return a.orgName.localeCompare(b.orgName);
        case 'ORG_DESC':
          return b.orgName.localeCompare(a.orgName);
        case 'LOC_ASC':
          return (
            a.orgCity.localeCompare(b.orgCity) || a.orgState.localeCompare(b.orgState)
          );
        case 'LOC_DESC':
          return (
            b.orgCity.localeCompare(a.orgCity) || b.orgState.localeCompare(a.orgState)
          );
        case 'DATE_ASC':
          return (new Date(a.auctionClosingDate ?? 0).getTime())
            - (new Date(b.auctionClosingDate ?? 0).getTime());
        case 'DATE_DESC':
          return (new Date(b.auctionClosingDate ?? 0).getTime())
            - (new Date(a.auctionClosingDate ?? 0).getTime());
        default: {
          return 0;
        }
      }
    });
  });
  //loggin
  authService = inject(AuthService);
  isShowingLoginIframe = signal(false);
  loginPage = LOGIN_TYPE_TOPBAR;
  loginUrl = signal('');


  // paginator
  page: number = 0;
  rowsPerPageOptions = [1, 2, 6, 10];
  first = signal(0);
  rows = signal(6);

  //filters
  filters = signal({
    category: 'current',
    country: null as string | null,
    state: null as string | null,
  });

  // paginatedAuctions = computed(() =>
  //   this.filteredAuctions()?.slice(this.first(), this.first() + this.rows()) ?? [] 

  filteredAuctions = computed(() => {
    const auctions = this.auctions();
    const causes = this.selectedCauses();

    return auctions?.filter(a => {
      const causesResult = causes.length === 0 || causes.includes(a.orgCause);

      return causesResult
    });

  });

  filteredCountries = computed(() =>
    this.country().filter(c => c.abbreviation === 'US' || c.abbreviation === 'CA')
  );


  selectedCountryName = computed(() => {
    const abbr = this.selectedCountries();
    if (!abbr) return null;

    return this.filteredCountries().find(c => c.abbreviation === abbr)?.name || null;
  });

  selectedStateName = computed(() => {
    const abbr = this.selectedState();
    if (!abbr) return null;

    return this.states().find((c: any) => c.abbreviation === abbr)?.name || null;
  });

  get causesLabel(): string {

    const causes = this.selectedCauses();

    if (causes && causes.length === 0) return 'Causes';

    if (causes.length === 1) return causes[0];
    if (causes.length === 2) return causes.join(', ');

    const firstTwo = causes.slice(0, 2).join(', ');
    return `${firstTwo} ...`;

  }



  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

      const category = this.route.snapshot.queryParams['category'] ?? null;

      if (category) {
        this.filters.update(f => ({
          ...f,
          category
        }));
      }

      this.auctionListingService.getAuctionListing(this.filters()).subscribe();


      this.getCauses();
      this.getCountries();

      window.addEventListener('resize', () => {
        this.viewMode = window.innerWidth < 1200
          ? 'image'
          : (this.viewMode ?? 'image');
      });

      this.isMobile = window.innerWidth < 768;


      this.authSubscription = this.authService.isAuthenticated$
        .pipe(
          distinctUntilChanged(),
          skip(1)
        )
        .subscribe(isAuth => {
          if (isAuth) {
            this.auctionListingService.getAuctionListing(this.filters()).subscribe();
          } else {
            this.clearFilters();
            this.auctionListingService.getAuctionListing(this.filters()).subscribe();
          }
        });
    }
  }

  getAuctionListing(category?: string) {

    if (category) {
      this.filters.update(f => ({
        ...f,
        category: category
      }));
    }
    this.auctionListingService.getAuctionListing(this.filters()).subscribe();
  }

  getCauses() {
    this.auctionListingService.getCauses().subscribe();
  }

  onPageChange(event: any) {
    this.first.set(event.first);
    this.rows.set(event.rows);
  }

  getCountries() {
    this.apiService.getCountries().subscribe();
  }

  onCountryChange(value: string) {

    this.bottomSheetCountryVisible = false;
    this.selectedCountries.set(value);

    this.filters.update(f => ({
      ...f,
      country: value,
      state: null
    }));

    this.auctionListingService.getAuctionListing(this.filters()).subscribe();

    this.getStates();
  }

  onStateChange(value: string) {

    this.filters.update(f => ({
      ...f,
      state: value,
      country: this.selectedCountries()
    }));

    this.auctionListingService.getAuctionListing(this.filters()).subscribe();

    this.bottomSheetStateVisible = false;
  }

  getStates() {

    const country = this.selectedCountries();

    if (!country) {
      this.states.set([]);
      this.selectedState.set(null);
      return;
    }

    this.apiService.getStates(country).subscribe({
      next: (result) => {
        this.states.set(result);
        this.selectedState.set(null);
      }
    });
  }

  onButtonCategoryFilterClick(id: string) {

    this.selectedCategory.set(id);


    if (id === 'local' && !this.isAuthenticated().isAuthenticated) {
      this.openLoginModal(() => {
        this.getAuctionListing('local');
      });

    } else {
      this.filters.update(f => ({
        ...f,
        category: id,
        country: this.selectedCountries()
      }));

      this.auctionListingService.getAuctionListing(this.filters()).subscribe();
    }

  }

  clearFilters() {
    this.filters = signal({
      category: 'current',
      country: null as string | null,
      state: null as string | null,
    });

    this.selectedState.set(null);
    this.selectedCategory.set('current');
    this.selectedCountries.set(null);
    this.selectedCauses.set([]);
    this.selectedSortSignal.set('');

    this.auctionListingService.getAuctionListing(this.filters()).subscribe();

  }

  openLoginModal(fun?: () => void) {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun ?? (() => { })
    );
  }


  openBottomSheet() {
    this.bottomSheetCausesVisible = true;
  }

  closeBottomSheet() {
    this.bottomSheetCausesVisible = false;
  }

  openBottomSheetCountry() {
    this.bottomSheetCountryVisible = true;
  }

  closeBottomSheetCountry() {
    this.bottomSheetCountryVisible = false;
  }

  openBottomSheetState() {
    if (this.selectedCountries()) {
      this.bottomSheetStateVisible = true;
    }
  }

  closeBottomSheetState() {
    this.bottomSheetStateVisible = false;
  }

  toggleCause(cause: string) {
    const current = this.selectedCauses();
    if (current.includes(cause)) {
      this.selectedCauses.set(current.filter(c => c !== cause));
    } else {
      this.selectedCauses.set([...current, cause]);

    }
  }

  onMyAuctionsChanged(myAuction: IAuctionListing | null): void {
    this.auctions.update(list => {
      if (!list) return list;

      return list.map(item =>
        item.auctionId === myAuction?.auctionId
          ? { ...item, isFavorite: !item.isFavorite }
          : item
      );
    });
  }
}
